module.exports = __webpack_public_path__ + "img/deposit_promote-account.d0eadae3.png";